import { createContext, useContext } from 'react';

/**
 * Set to true by `StiggProvider`. Lives outside the SDK so the check costs
 * nothing in the portal chunk; components that pass it lazy-load the SDK
 * hooks they need.
 */
export const StiggMountedContext = createContext(false);

/**
 * Whether a `StiggProvider` is above this component. `PortalBillingProvider`
 * renders the dashboard without it until a tenant is selected and the SDK
 * chunk loads, so billing UI checks this before loading other SDK hooks.
 */
export const useIsStiggMounted = () => useContext(StiggMountedContext);
